export const AUTH_SIGNUP = "AUTH_SIGNUP";
export const AUTH_LOGIN = "AUTH_LOGIN";
export const AUTH_START = "AUTH_START";
export const AUTH_FAILED = "AUTH_FAILED";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_CHECK_STATE = "AUTH_CHECK_STATE";

export const DATA_FETCH_FAIL = "DATA_FETCH_FAIL";
export const DATA_FETCH_SUCCESS = "DATA_FETCH_SUCCESS";
export const DATA_FETCH_START = "DATA_FETCH_START";
export const DATA_FETCH = "DATA_FETCH";
